import React from "react";

export default function SpSolution() {
  return (
    <React.Fragment>
      <div className="row px-6 my-5 ">
        <div className="col-12 spClientRequirementDiv bg-white">
          <div className="row align-items-center flex-column-reverse flex-md-row">
            <div className="col-md-6">
              <video
                width="100%"
                controls={false}
                loop
                autoPlay
                muted
                playsInline
                height={window.innerWidth < 900 ? "250px" : "400px"}
              >
                <source src="/images/SpOurSolution.mp4" type="video/mp4" />
                Your browser does not support the video tag.
              </video>
            </div>
            <div className="col-md-6 ps-3 ps-md-5">
              <h2>Our Solution</h2>
              <p>
                We developed Superbuildup as an all in one ERP solution that
                resolves all the issues and fulfils specific needs of the
                client. The software removes scattered processes and gives
                builders the tools to manage sales, financials, legal
                compliance, and on site operations with accuracy and efficiency.
              </p>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}
